var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headerActionConfig,
          "left-side-class": "col-xl-5 pb-2",
          page: _vm.headerConfig,
          "right-side-class":
            "col-xl-7 d-flex align-items-end pb-4 justify-content-end"
        }
      }),
      _c("rubric-form", {
        attrs: { "is-read-only": _vm.isReadOnly },
        model: {
          value: _vm.rubric,
          callback: function($$v) {
            _vm.rubric = $$v
          },
          expression: "rubric"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }